import { MotionConfig } from 'framer-motion';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout, ScrollToTop } from './components/layout';
import { Home, About, Services, ServiceDetail, Industries, IndustryDetail, Products, Contact, Careers, Investors, IstaLabs, ResearchDetail, NotFound } from './pages';

/**
 * Main Application Component
 * Sets up routing and the main layout structure
 */
function App() {
  return (
    <MotionConfig reducedMotion="user">
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Main Pages */}
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          {/* Individual "What We Do" service pages — the :serviceId
              is the slug from `src/data/whatWeDo.ts`, which is the
              same value emitted by the Contact form dropdown. */}
          <Route path="services/:serviceId" element={<ServiceDetail />} />
          <Route path="solutions" element={<Services />} />
          <Route path="solutions/:solutionId" element={<Services />} />
          {/* Industry landing pages — the :industryId is the slug
              from `src/data/industries.ts`, which is the same value
              used by the sidebar drawer's "Industries We Empower"
              sub-items AND by the Contact form's `industry` query
              param. Keep the three symmetrical if you rename slugs. */}
          <Route path="industries" element={<Industries />} />
          <Route path="industries/:industryId" element={<IndustryDetail />} />
          <Route path="products" element={<Products />} />
          <Route path="contact" element={<Contact />} />
          <Route path="careers" element={<Careers />} />
          <Route path="investors" element={<Investors />} />
          <Route path="istalabs" element={<IstaLabs />} />
          {/* "Research in practice" — single-entry detail page for
              records in the `in_parctice_research_and_documentsion`
              Mongo collection. `:entryId` accepts either the numeric
              `sorting_id` (clean, shareable URL like `/research/10`)
              or the stringified Mongo `_id` as a fallback — see
              ResearchDetail.tsx for the lookup logic. */}
          <Route path="research/:entryId" element={<ResearchDetail />} />
          
          {/* Placeholder routes for additional pages */}
          <Route path="blog" element={<NotFound />} />
          <Route path="case-studies" element={<NotFound />} />
          <Route path="resources/*" element={<NotFound />} />
          <Route path="privacy" element={<NotFound />} />
          <Route path="terms" element={<NotFound />} />
          
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
